<div class="header-box">
  <div class="d-flex align-items-center heading-box">
    <mat-icon class="header-icon">edit</mat-icon>
    <div>
      <h2>Account Master</h2>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <div class="status-display">
      <span class="status-label">Status:</span>
      <span class="status-value" [ngClass]="'status-' + getStatusColor(accountForm.get('status')?.value)">
        {{ getStatusLabel(accountForm.get('status')?.value) }}
      </span>
    </div>
    <button mat-raised-button color="accent" class="activate-button ml-3"
      *ngIf="!viewMode && accountForm.get('status')?.value === 'DRAFT'" (click)="activateAccount()">
      Activate
    </button>
  </div>
</div>

<div class="inner-box">
  <mat-card class="without-expansion">
    <mat-card-content class="form-head">
      <form [formGroup]="accountForm" class="account-form">
        <mat-accordion>
          <mat-expansion-panel expanded hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="viewMode; else editOrAdd">
                  View Account Master
                </ng-container>
                <ng-template #editOrAdd>
                  <ng-container *ngIf="isEdit; else addMode">
                    Edit Account Master
                  </ng-container>
                  <ng-template #addMode>
                    Add Account Master
                  </ng-template>
                </ng-template>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="col-md-12 d-flex p-0">
              <!-- Left Column -->
              <div class="col-md-6">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Type</mat-label>
                    <mat-select formControlName="type">
                      <mat-option value="CUSTOMER">Customer</mat-option>
                      <mat-option value="VENDOR">Vendor</mat-option>
                      <mat-option value="PARTNER">Partner</mat-option>
                      <mat-option value="OTHER">Other</mat-option>
                    </mat-select>
                    <mat-icon matSuffix matTooltip="Account type information">help_outline</mat-icon>
                    <mat-error *ngIf="accountForm.get('type')?.hasError('required')">
                      Account Type is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="dense-2" *ngIf="isEdit || viewMode">
                  <mat-form-field appearance="outline">
                    <mat-label>Account ID</mat-label>
                    <input matInput formControlName="id" placeholder="System generated" readonly>
                    <mat-icon matSuffix
                      matTooltip="System generated account identifier (read-only)">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Additional ID</mat-label>
                    <input matInput formControlName="additionalId" placeholder="Enter additional account ID">
                    <mat-icon matSuffix matTooltip="Additional account identifier">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Address</mat-label>
                    <input matInput formControlName="address" placeholder="Enter account address">
                    <mat-icon matSuffix matTooltip="Account address information">help_outline</mat-icon>
                    <mat-error *ngIf="accountForm.get('address')?.hasError('required')">
                      Account Address is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account State</mat-label>
                    <input matInput formControlName="state" placeholder="Enter state">
                    <mat-icon matSuffix matTooltip="State information">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Zip/Pin Code</mat-label>
                    <input matInput formControlName="zipCode" placeholder="Enter zip/pin code">
                    <mat-icon matSuffix matTooltip="Postal code information">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Contact Email</mat-label>
                    <input matInput formControlName="contactEmail" type="email" placeholder="Enter contact email">
                    <mat-icon matSuffix matTooltip="Primary contact email">help_outline</mat-icon>
                    <mat-error *ngIf="accountForm.get('contactEmail')?.hasError('email')">
                      Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Contact Signatory Name</mat-label>
                    <input matInput formControlName="contactSignatoryName" placeholder="Enter signatory name">
                    <mat-icon matSuffix matTooltip="Contact signatory person name">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Contact Signatory Email</mat-label>
                    <input matInput formControlName="contactSignatoryEmail" type="email"
                      placeholder="Enter signatory email">
                    <mat-icon matSuffix matTooltip="Contact signatory email address">help_outline</mat-icon>
                    <mat-error *ngIf="accountForm.get('contactSignatoryEmail')?.hasError('email')">
                      Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Right Column -->
              <div class="col-md-6">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Source Type</mat-label>
                    <mat-select formControlName="sourceType">
                      <mat-option value="MANUAL">Manual</mat-option>
                      <mat-option value="INTEGRATION">Integration</mat-option>
                    </mat-select>
                    <mat-icon matSuffix matTooltip="How the account was created">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Name</mat-label>
                    <input matInput formControlName="name" placeholder="Enter account name">
                    <mat-icon matSuffix matTooltip="Account name information">help_outline</mat-icon>
                    <mat-error *ngIf="accountForm.get('name')?.hasError('required')">
                      Account Name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account City</mat-label>
                    <input matInput formControlName="city" placeholder="Enter city">
                    <mat-icon matSuffix matTooltip="City information">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Country</mat-label>
                    <input matInput formControlName="country" placeholder="Enter country">
                    <mat-icon matSuffix matTooltip="Country information">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Contact Name</mat-label>
                    <input matInput formControlName="contactName" placeholder="Enter contact name">
                    <mat-icon matSuffix matTooltip="Primary contact person">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Contact Number</mat-label>
                    <input matInput formControlName="contactNumber" placeholder="Enter contact number">
                    <mat-icon matSuffix matTooltip="Primary contact number">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Risk Score</mat-label>
                    <input matInput formControlName="riskScore" type="number" step="0.01"
                      placeholder="System calculated" readonly>
                    <mat-icon matSuffix matTooltip="System calculated risk score (read-only)">help_outline</mat-icon>
                  </mat-form-field>
                </div>

                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Overdue Obligations Count</mat-label>
                    <input matInput formControlName="overdueObligationCount" type="number"
                      placeholder="System calculated" readonly>
                    <mat-icon matSuffix
                      matTooltip="System calculated overdue obligations count (read-only)">help_outline</mat-icon>
                  </mat-form-field>
                </div>
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Status</mat-label>
                    <mat-select formControlName="status" (selectionChange)="onStatusChange()">
                      <mat-option value="DRAFT">Draft</mat-option>
                      <mat-option value="ACTIVE">Active</mat-option>
                      <mat-option value="INACTIVE">Inactive</mat-option>
                      <mat-option value="BLACKLISTED">Blacklisted</mat-option>
                    </mat-select>
                    <mat-icon matSuffix matTooltip="Account status information">help_outline</mat-icon>
                    <mat-error *ngIf="accountForm.get('status')?.hasError('required')">
                      Account Status is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="d-flex col-md-12 justify-content-between p-0 mt-4">
          <button mat-button class="back-button" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            Back
          </button>
          <button mat-raised-button color="accent" class="save-button" *ngIf="!viewMode"
            [disabled]="accountForm.invalid || isSubmitting" (click)="saveAccount()">
            <mat-icon *ngIf="isSubmitting">refresh</mat-icon>
            <ng-container *ngIf="!isSubmitting">
              {{ isEdit ? 'Update' : 'Save' }}
            </ng-container>
            <ng-container *ngIf="isSubmitting">
              {{ isEdit ? 'Updating...' : 'Saving...' }}
            </ng-container>
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>